import { audiobooks } from "@/mocks/homeData";

export default function AudioSection() {
  return (
    <section id="audio" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-10">
          <div className="lg:col-span-1">
            <span className="text-xs md:text-sm font-label tracking-[0.2em] text-primary-600 uppercase">
              Audio Books
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              中文在线听书资源
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              真人播讲的有声小说、评书与知识解读频道，支持后台连续播放与定时关闭。
              做家务、跑步或通勤时，闭上眼睛也能把故事听完。
            </p>

            <ul className="mt-6 flex flex-col gap-3">
              {[
                { icon: "ri-play-circle-line", text: "后台连续播放，切到其他应用不断音" },
                { icon: "ri-timer-line", text: "定时关闭，睡前听书自动停止" },
                { icon: "ri-equalizer-line", text: "音色与语速可调，听感更舒适" },
              ].map((f) => (
                <li key={f.text} className="flex items-center gap-3 text-sm text-foreground-700">
                  <span className="w-9 h-9 rounded-lg bg-secondary-100 text-secondary-700 flex items-center justify-center text-lg shrink-0">
                    <i className={f.icon} aria-hidden="true"></i>
                  </span>
                  {f.text}
                </li>
              ))}
            </ul>

            <div className="mt-7 rounded-lg bg-foreground-950 p-5 text-background-50">
              <div className="flex items-center gap-3">
                <span className="w-11 h-11 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-xl">
                  <i className="ri-headphone-line" aria-hidden="true"></i>
                </span>
                <div>
                  <p className="font-heading text-base font-bold">今日推荐专辑</p>
                  <p className="text-xs text-background-200">《大江东去》· 共 120 集</p>
                </div>
              </div>
              <p className="mt-4 text-xs text-background-100/85 leading-relaxed">
                厚重沉稳的旁白，把一段跨越数十年的时代群像讲得引人入胜，适合长时间连续收听。
              </p>
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {audiobooks.map((a, idx) => (
                <article
                  key={a.id}
                  className="group flex gap-4 rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-secondary-300"
                >
                  <div className="relative w-14 h-14 md:w-16 md:h-16 shrink-0 rounded-lg bg-secondary-500 text-background-50 flex items-center justify-center text-2xl">
                    <i className="ri-music-2-line" aria-hidden="true"></i>
                    <span className="absolute -bottom-1 -right-1 w-6 h-6 rounded-full bg-background-50 text-primary-600 flex items-center justify-center text-base">
                      <i className="ri-play-fill" aria-hidden="true"></i>
                    </span>
                  </div>
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2">
                      <h3 className="font-heading text-base font-bold text-foreground-950 truncate">
                        {a.title}
                      </h3>
                      <span className="px-2 py-0.5 rounded bg-accent-100 text-accent-800 text-[10px] whitespace-nowrap shrink-0">
                        {a.tag}
                      </span>
                    </div>
                    <p className="mt-1 text-[11px] text-foreground-500">
                      {a.narrator} 播讲 · {a.episodes}
                    </p>
                    <p className="mt-2 text-xs text-foreground-600 leading-relaxed line-clamp-2">{a.intro}</p>
                    <div className="mt-2.5 flex items-center justify-between text-[11px] text-foreground-500">
                      <span>
                        <i className="ri-time-line mr-1" aria-hidden="true"></i>
                        {a.duration}
                      </span>
                      <span className="text-secondary-700 font-medium">第 {idx + 1} 频道</span>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}